import { render, staticRenderFns } from "./dm-detail-dianping.vue?vue&type=template&id=a155708e&scoped=true"
import script from "./dm-detail-dianping.vue?vue&type=script&lang=js"
export * from "./dm-detail-dianping.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-dianping.vue?vue&type=style&index=0&id=a155708e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a155708e",
  null
  
)

export default component.exports